/**
 * Hazard: sensor body that triggers a death event on player contact.
 * Drawn as a red spike strip.
 */

import Matter from 'matter-js';
import { Graphics } from 'pixi.js';

export interface HazardOptions {
  x: number;
  y: number;
  w: number;
  h: number;
}

export class Hazard {
  readonly body: Matter.Body;
  readonly view: Graphics;

  constructor(opts: HazardOptions) {
    this.body = Matter.Bodies.rectangle(
      opts.x + opts.w / 2,
      opts.y + opts.h / 2,
      opts.w,
      opts.h,
      { isStatic: true, isSensor: true, label: 'hazard' },
    );

    const g = new Graphics();
    // Spike row.
    const spikeW = 16;
    const count = Math.max(1, Math.floor(opts.w / spikeW));
    const actualW = opts.w / count;
    for (let i = 0; i < count; i++) {
      const x0 = opts.x + i * actualW;
      g.moveTo(x0, opts.y + opts.h)
        .lineTo(x0 + actualW / 2, opts.y)
        .lineTo(x0 + actualW, opts.y + opts.h)
        .closePath()
        .fill(0xc83a3a)
        .stroke({ color: 0x401010, width: 1.5 });
    }
    this.view = g;
  }
}
